module.exports = __webpack_public_path__ + "2d0c51ba92809ec8cf24860cad8ac138.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/retro-gaming-system.png
// module id = 3043
// module chunks = 0